import React, { useState } from 'react'
import Select from "react-select"
import { Dropdown, Menu, Select as AntSelect } from 'antd'
import { Link, Route, Switch, useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { useListData, usePet, useToggle } from '../modules'

import Receive from '../components/resusable/receive'
import NewSaleItem from '../components/modals/newsaleitem'
import AddVariant from '../components/modals/addVariant'
import SaleItem from '../components/modals/saleItem'
import RoomGroup from '../components/drawers/roomGroup'
import pluralize from 'pluralize'

const { Option } = AntSelect

const Rooms = () => {
    const { id } = useParams()

    const [string, setString] = useState('')
    const [category, setCategory] = useState()
    const [selected, setSelected] = useState()

    const [saleItemModal, toggleSaleItemModal] = useToggle()
    const [newSaleItemModal, toggleNewSaleItemModal] = useToggle()
    const [addVariantModal, toggleAddVariantModal] = useToggle()

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems }, 
        { list: saleItems }, 
        { navigate, Paginate, page, limit }
    ] = useListData('accommodations', {
        string,
        category: category?.label
    }, { notify: true }, 'items')

    const [{ loading: catsLoading, error: catsError, data: categories = [] }, fetchCats] = usePet('accommodationCategories', null, { notify: true })
    
    const addVariant = itm => {
        setSelected(itm)
        toggleAddVariantModal()
    }
    
    const viewSaleItem = itm => {
        setSelected(itm)
        toggleSaleItemModal()
    }
    
    const toggleAvailability = itm => {
        setSelected(itm)
        toggleItemAvailability()
    }
    
    const changeCategory = val => {
        setCategory(val)
        fetchItems()
    }
    
    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0) {
            fetch()
            navigate(1)
        }
    }
    
    const refetch = () => {
        fetchItems()
        fetchCats()
    }
    
    const onComplete = ({ data }, notif, ops) => {
        notif(`Item is now ${ data.unavailable ? 'unavailable' : 'available' }`, ops('success'))
        fetchItems()
    }

    const [, toggleItemAvailability] = usePet('toggleSaleItemAvailability', {
        id: selected?._id
    }, { notify: true, callback: onComplete, manual: true })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Sale Items" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    {/* Filter button */}
                    {/* <FilterButton
                        options={['prepared', 'sale items', 'service']} /> */}
                    <Link to="/app/rooms/new">
                        <button className="btn hisani-btn-green text-white">
                            <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                            </svg>
                            <span className="hidden xs:block ml-2">New Room Group</span>
                        </button>
                    </Link>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <Receive
                    error={itemsError}
                    loading={itemsLoading}
                    progress>
                    <>
                        <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                            <h2 className="font-semibold text-gray-800">Rooms Groups</h2>
                            <Receive
                                error={catsError}
                                loading={catsLoading}
                                progress>
                                <Select
                                    isClearable
                                    value={ category }
                                    onChange={ changeCategory }
                                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                    options={categories?.map(category => ({ label: category, value: category }))}
                                    placeholder="Category" />
                            </Receive>
                        </header>
                        <div className="p-3">
                            <div className="overflow-x-auto">
                                <Receive
                                    error={itemsError}
                                    loading={itemsLoading}
                                    progress>
                                    {
                                        saleItems.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Category</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Rooms</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Status</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Opened On</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        saleItems.map((item, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ ((page - 1) * limit) + (key + 1) }.</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{item.name}</div>
                                                                    <p className="text-gray-500 text-xs italic">{item.type}</p>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{item.category}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ item.variants.length } { pluralize('room', item.variants.length) }</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center text-green-500">{ item.unavailable ? 'Unavailable' : 'Available' }</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <Dropdown
                                                                        overlay={
                                                                            <Menu>
                                                                                <Link to={ `/app/rooms/${item._id}`}>
                                                                                    <Menu.Item>View</Menu.Item>
                                                                                </Link>
                                                                                { item?.type !== 'variant' && <Menu.Item onClick={ () => addVariant(item) }>Add Variant</Menu.Item> }
                                                                                <Menu.Item onClick={ () => toggleAvailability(item) }>Make { item.unavailable ? 'Available' : 'Unavailable' }</Menu.Item>
                                                                            </Menu>
                                                                        }>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="flex font-semibold text-md justify-center items-center">
                                                <h2>Please click above to add some items</h2>
                                            </div>
                                    }
                                </Receive>
                                {Paginate}
                            </div>
                        </div>
                        <Switch>
                            <Route path="/app/rooms/:id">
                                <RoomGroup onPerform={ refetch } />
                            </Route>
                        </Switch>
                    </>
                </Receive>
            </div>
        </div>
    )
}

export default Rooms